import { render, staticRenderFns } from "./virtual-grid.vue?vue&type=template&id=5099bf29&"
import script from "./virtual-grid.vue?vue&type=script&lang=ts&"
export * from "./virtual-grid.vue?vue&type=script&lang=ts&"
import style0 from "./virtual-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports